<template>
  <div class="boleto-message">
    <AmTypography
      class="boleto-message__payment__boleto__compensation"
      text="Pagamentos via boleto são efetuados à vista."
      typography-style="l5"
    />
    <AmTypography
      class="boleto-message__payment__boleto__compensation"
      text="A compensação do pagamento pode levar até 3 dias úteis."
      typography-style="l5"
    />
  </div>
</template>

<script>
export default {
  name: 'BoletoMessage',
}
</script>

<style lang="scss" scoped>
.boleto-message {
  margin-top: 16px;
  &__payment__boleto__compensation {
    text-align: center;
  }
}
</style>
